import { cn } from "@newxsystems/shared";
import { getKaajSectionSpacing } from "../../../../modules/layout/kaaj-section-spacing";
import { RichTextHtml } from "../../RichTextHtml";
import type { IWysiwygBlockProps } from "./WysiwygBlock.props";

const lightTheme = {
  section: "text-[#151927]",
};

export const WysiwygBlock = ({
  parentClass,
  heading,
  subheading,
  content,
  spacing,
}: IWysiwygBlockProps) => {
  const hasContent = Boolean(content);
  const hasHeader = Boolean(heading || subheading);
  if (!hasHeader && !hasContent) {
    return null;
  }

  return (
    <section
      className={cn(
        "relative isolate overflow-hidden",
        lightTheme.section,
        getKaajSectionSpacing(spacing),
        parentClass,
      )}
    >
      <div className="kaaj-container relative">
        <article className="text-[#151927]">
          <div className="relative min-w-0">
            {hasHeader ? (
              <header className="border-b border-[#D9E1FF] pb-4 mb-4 sm:pb-6 sm:mb-6">
                {heading ? (
                  <h2 className="kaaj-section-heading text-[#151927]">{heading}</h2>
                ) : null}
                {subheading ? (
                  <RichTextHtml
                    className="mt-5 text-pretty text-base leading-7 text-[#4B5568] sm:text-lg sm:leading-8"
                    html={subheading}
                  />
                ) : null}
              </header>
            ) : null}

            {hasContent ? <RichTextHtml className={cn("prose")} html={content} /> : null}
          </div>
        </article>
      </div>
    </section>
  );
};

WysiwygBlock.displayName = "Block::WysiwygBlock";
